import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Button, Pagination, Box, Dialog, DialogTitle, DialogContent, DialogActions, TextField,

    MenuItem,
} from "@mui/material";
import { FaRegEdit, FaTrash } from "react-icons/fa";
import ArrowBack from "@mui/icons-material/ArrowBack";
import apiService from "../../service/apiService";

import { Autocomplete } from "@mui/material";


const ChildFfd = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const farmerFieldDaysId = location.state?.farmerFieldDaysId; // Extract ID from state
    const [formattedData, setFormattedData] = useState({});
    const [farmers, setFarmers] = useState([]);
    const [selectedFarmerId, setSelectedFarmerId] = useState("");


    // const [farmers, setFarmers] = useState([]);
    // const [selectedFarmerId, setSelectedFarmerId] = useState("");
    // const [formattedData, setFormattedData] = useState(location.state?.formattedData || {});
    // const farmerFieldDaysId = formattedData?.farmerFieldDaysId;

    const [page, setPage] = useState(1);
    const pageSize = 10;
    const totalItems = formattedData?.farmers?.length || 0;
    const totalPages = Math.ceil(totalItems / pageSize);

    const [openDialog, setOpenDialog] = useState(false);
    const [newFarmerName, setNewFarmerName] = useState("");



    const fetchData = async () => {
        if (!farmerFieldDaysId) {
            console.error("farmerFieldDaysId is not available");
            return;
        }

        try {
            const response = await apiService.get(`/farmer-field-days/getFarmerDetails/${farmerFieldDaysId}`);
            if (response.status === 200) {
                setFormattedData(response.data); // Set the fetched data
            } else {
                console.error("Failed to fetch details:", response);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    useEffect(() => {

        fetchData();
    }, [farmerFieldDaysId]);


    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleBack = () => {
        navigate(-1);
    };

    const handleEdit = (farmerId) => {
        console.log("Edit farmer with ID:", farmerId);
    };

    useEffect(() => {
        const fetchFarmers = async () => {
            try {
                const response = await apiService.get(
                    "/farmers/get-all"
                );
                if (response.status === 200) {
                    setFarmers(response.data); // Set the farmers data
                } else {
                    console.error("Failed to fetch farmers:", response);
                }
            } catch (error) {
                console.error("Error fetching farmers:", error);
            }
        };

        fetchFarmers();
    }, []);

    const handleDelete = async (farmerId) => {
        if (!farmerFieldDaysId) {
            console.error("farmerFieldDaysId is not available");
            return;
        }

        const confirmDelete = window.confirm("Are you sure you want to delete this farmer?");
        if (!confirmDelete) return;

        try {
            const response = await apiService.delete(
                `/farmer-field-days/delete-farmer/${farmerId}/${farmerFieldDaysId}`
            );

            if (response.status === 200) {
                alert("Farmer deleted successfully!");
                const updatedFarmers = formattedData.farmers.filter((farmer) => farmer.farmerId !== farmerId);
                setFormattedData({ ...formattedData, farmers: updatedFarmers });
                fetchData();
            } else {
                alert("Failed to delete farmer.");
            }
        } catch (error) {
            console.error("Error deleting farmer:", error);
            alert("An error occurred while deleting the farmer.");
        }
    };

    const handleOpenDialog = () => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleSaveFarmer = async () => {
        if (!selectedFarmerId) {
            alert("Please select a farmer.");
            return;
        }

        if (!farmerFieldDaysId) {
            console.error("farmerFieldDaysId is not available");
            return;
        }

        const payload = {
            farmerId: selectedFarmerId,
        };

        try {
            const response = await apiService.post(
                `/farmer-field-days/addFarmer/${farmerFieldDaysId}`,
                payload
            );

            if (response.status === 200) {
                alert("Farmer added successfully!");
                fetchData();
                const newFarmer = response.data;
                setFarmers([...farmers, newFarmer]);
                setFormattedData({
                    ...formattedData,
                    farmers: [...formattedData.farmers, newFarmer],
                });
            } else {
                alert("Failed to add farmer.");
            }
        } catch (error) {
            console.error("Error adding farmer:", error);
            alert("An error occurred while adding the farmer.");
        }

        setNewFarmerName("");
        handleCloseDialog();
        setSelectedFarmerId("");
    };



    if (!formattedData || !formattedData.farmers) {
        return <div>No data available</div>;
    }

    return (
        <div>
            <h3>Farmer Field Days Details</h3>

            <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    gap: 2,
                    marginTop: 2,
                    marginBottom: 2,
                    paddingLeft: 2,
                }}
            >
                <Button
                    startIcon={<ArrowBack />}
                    onClick={handleBack}
                    sx={{
                        backgroundColor: "#1976d2",
                        color: "white",
                        "&:hover": {
                            backgroundColor: "#1565c0",
                        },
                        padding: "6px 16px",
                    }}
                >
                    Back
                </Button>
            </Box>



            <div className="table-responsive mx-2" style={{ maxHeight: "75vh", overflowY: "auto" }}>
                <table className="table table-bordered mb-0" style={{ minWidth: "1200px" }}>
                    <thead>
                        <tr>
                            <th style={{ backgroundColor: "#1c78d4", color: "#fff", fontSize: "18px" }}>PG Name</th>
                            {/* <th style={{ backgroundColor: "#1c78d4", color: "#fff", fontSize: "18px" }}>Farmer ID</th> */}
                            <th style={{ backgroundColor: "#1c78d4", color: "#fff", fontSize: "18px" }}>Farmer Name</th>
                            <th style={{ backgroundColor: "#1c78d4", color: "#fff", fontSize: "18px" }}>Gender</th>
                            <th style={{ backgroundColor: "#1c78d4", color: "#fff", fontSize: "18px" }}>Caste</th>
                            <th style={{ backgroundColor: "#1c78d4", color: "#fff", fontSize: "18px" }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {formattedData.farmers.slice((page - 1) * pageSize, page * pageSize).map((farmer, index) => (
                            <tr key={index}>
                                <td>{farmer.producerGroupName}</td>
                                {/* <td>{farmer.farmerId}</td> */}
                                <td>{farmer.farmerName}</td>
                                <td>{farmer.gender}</td>
                                <td>{farmer.caste}</td>
                                <td>
                                    <Box sx={{ display: "flex", gap: 1 }}>
                                        {/* <button
                                            className="btn btn-md me-2"
                                            onClick={() => handleEdit(farmer.farmerId)}
                                            title="Edit"
                                        >
                                            <FaRegEdit />
                                        </button> */}
                                        <button
                                            className="btn btn-md"
                                            onClick={() => handleDelete(farmer.farmerId)}
                                            title="Delete"
                                        >
                                            <FaTrash />
                                        </button>
                                    </Box>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="d-flex justify-content-between pb-0">
                <div className="p-2">
                    Showing {(page - 1) * pageSize + 1} to {Math.min(page * pageSize, totalItems)} of {totalItems} items
                </div>
                <div className="p-2">
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        showFirstButton
                        showLastButton
                    />
                </div>
            </div>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                PaperProps={{
                    sx: {
                        width: "600px",
                        maxWidth: "600px",
                    },
                }}
            >
                <DialogTitle sx={{ marginBottom: 0 }}> Add Farmer Field Days</DialogTitle>
                <DialogContent>
                    <Autocomplete
                        options={farmers}
                        getOptionLabel={(option) => option.farmerName || ""}
                        value={farmers.find((farmer) => farmer.farmerId === selectedFarmerId) || null}
                        onChange={(event, newValue) => {
                            setSelectedFarmerId(newValue?.farmerId || "");
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Farmer Name"
                                variant="outlined"
                                fullWidth
                                sx={{ marginTop: 2 }}
                            />
                        )}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="secondary">
                        Close
                    </Button>
                    <Button onClick={handleSaveFarmer} color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
};

export default ChildFfd;
